module.exports = __webpack_public_path__ + "img/big.f1a3433f.jpg";